import Attendee from './Attendee';

export default Attendee;
